<template>
  <modal
    v-slot="{ data }"
    name="signInWithPasscodeModal"
    modal-style="compact"
    :display-header-title="false"
  >
    <sign-in-with-passcode :sign-in-method="data.signInMethod" />
  </modal>
</template>


<script>
  import SignInWithPasscode from './sign-in-with-passcode/index.vue';


  export default {
    name: 'SignInWithPasscodeModal',

    components: {
      SignInWithPasscode
    }
  };
</script>
